:host {
  display: block;
  width: 100%;
  height: 100%;
  text-align: initial;
  .bell-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    height: 100%;
    width: 100%;
    cursor: pointer;
    color: var(--module-news-icon-bell-color, #666);

    & > .tooltip-slot-container {
      position: absolute;
      inset: 0;
      // Displayed as grid to ensure that the element set in the slot takes all the available space
      display: grid;
    }

    .trigger-wrapper {
      height: 20px;
      width: 20px;
      line-height: 0;
    }
    span {
      position: absolute;
      left: 70%;
      top: 45%;
      translate: -50% -50%;
      padding: 0 6px;
      line-height: 18px;
      border-radius: 20px;
      text-align: center;
      font-size: 12px;
      font-weight: 400;
      background: #0098ff;
      color: #fff;
      transition: 0.3s;
      opacity: 1;
      transform: scale(1);
      &.has-events {
        background: #ff8500;
      }
    }
    .bell-animation {
      transform-origin: 50% 50%;
      animation: bellringNews 1s ease-out;
      &.has-events {
        transform-origin: 50% 50%;
        animation: bellringEvents 1s ease-out;
      }
    }
    @keyframes bellringNews {
      0% {
        transform: rotate(35deg);
        fill: #0098ff;
      }
      12.5% {
        transform: rotate(-30deg);
      }
      25% {
        transform: rotate(25deg);
      }
      37.5% {
        transform: rotate(-20deg);
      }
      50% {
        transform: rotate(15deg);
        fill: #0098ff;
      }
      62.5% {
        transform: rotate(-10deg);
      }
      75% {
        transform: rotate(5deg);
      }
      100% {
        transform: rotate(0);
        fill: currentColor;
      }
    }
    @keyframes bellringEvents {
      0% {
        transform: rotate(35deg);
        fill: #ff8500;
      }
      12.5% {
        transform: rotate(-30deg);
      }
      25% {
        transform: rotate(25deg);
      }
      37.5% {
        transform: rotate(-20deg);
      }
      50% {
        transform: rotate(15deg);
        fill: #ff8500;
      }
      62.5% {
        transform: rotate(-10deg);
      }
      75% {
        transform: rotate(5deg);
      }
      100% {
        transform: rotate(0);
        fill: currentColor;
      }
    }
  }
}
